/* LP landing kit: carruseles, anclas suaves y barra fija. Se carga desde cada sección lp-*; el guard evita dobles inicializaciones. */
(function () {
  if (window.__lpLandingInit) return;
  window.__lpLandingInit = true;

  function initCarousel(root) {
    if (root.__lpCar) return;
    root.__lpCar = true;
    var track = root.querySelector('.lp-car__track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var prev = root.querySelector('[data-lp-prev]');
    var next = root.querySelector('[data-lp-next]');
    var dotsBox = root.querySelector('[data-lp-dots]');
    var dots = [];

    function step() {
      if (slides.length < 2) return track.clientWidth;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }
    function current() {
      var s = step() || 1;
      return Math.round(track.scrollLeft / s);
    }
    function maxIndex() {
      var s = step() || 1;
      return Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / s));
    }
    function go(i) {
      var max = maxIndex();
      if (i > max) i = 0;
      if (i < 0) i = max;
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
    }
    // Un punto por posición alcanzable (no por slide): en escritorio caben varias a la vez.
    function buildDots() {
      if (!dotsBox) return;
      dotsBox.innerHTML = '';
      dots = [];
      var n = maxIndex() + 1;
      dotsBox.style.display = n < 2 ? 'none' : '';
      for (var i = 0; i < n && n > 1; i++) {
        (function (k) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'lp-car__dot';
          b.setAttribute('aria-label', 'Ir a la posición ' + (k + 1) + ' de ' + n);
          b.addEventListener('click', function () { go(k); });
          dotsBox.appendChild(b);
          dots.push(b);
        })(i);
      }
    }
    function sync() {
      var i = Math.min(current(), dots.length - 1);
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { buildDots(); sync(); }, 150);
    });
    buildDots();
    sync();
  }

  function initSticky() {
    var bar = document.querySelector('[data-lp-sticky]');
    if (!bar || bar.__lpSticky) return;
    bar.__lpSticky = true;
    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-lp-hide-sticky], #lp-buy'));
    var buy = document.getElementById('lp-buy');
    if (buy) {
      var info = buy.closest('.product__info-wrapper, .product__info-container, .product');
      if (info) targets.push(info);
    }
    if (!('IntersectionObserver' in window) || !targets.length) return;
    var visible = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target); });
      bar.classList.toggle('is-hidden', visible.size > 0);
    }, { threshold: 0.15 });
    targets.forEach(function (t) { io.observe(t); });
  }

  function initAnchors() {
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('a[href^="#lp-"]');
      if (!a) return;
      var el = document.getElementById(a.getAttribute('href').slice(1));
      if (!el) return;
      ev.preventDefault();
      var y = el.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lp-carousel]'), initCarousel);
    initSticky();
  }
  initAnchors();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lp-carousel]'), initCarousel);
  });
})();